import { isReactClass } from './isReactClass';
/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isDynamicSetter(obj) {
  return obj && typeof obj === 'function' && !isReactClass(obj);
}